export default {"src":"/_next/static/media/solvar_white_01.266c3f74.svg","height":246,"width":1102,"blurWidth":0,"blurHeight":0};